module.exports = __webpack_public_path__ + "static/media/Blog1.8ea2e9af.jpeg";